module.exports = __webpack_public_path__ + "assets/img/AI.d957a1b8.png";